import * as types from '../actions/types'
import createReducer from '../createReducer'

const initialState = false

export const appReady = createReducer(initialState, {
  [types.INIT_APP](state, action) {
    return true
  },
})

type GlobalsInitialState = {
  titlePrivacy: string,
  labelSubscribeNewsletter: string,
  privacyStatement: string,
  reportingForm: unknown,
  documentationForm: unknown,
} | null

const globalsInitialState: GlobalsInitialState = null

export const globals = createReducer(globalsInitialState, {
  [types.INIT_APP](state, action): GlobalsInitialState {
    const { payload: p } = action
    return {
      titlePrivacy: p.title_privacy,
      labelSubscribeNewsletter: p.label_subscribe_newsletter,
      privacyStatement: p.privacy_statement,
      reportingForm: p.reporting_form,
      documentationForm: p.documentation_form,
    }
  }
})

const resourceInitialState = {
  list: {},
  current: null,
}

export const resources = createReducer(resourceInitialState, {
  [types.SET_RESOURCE](state, action) {
    const { resourceKey, resourceData } = action
    const newList = { ...state.list }
    newList[resourceKey] = resourceData

    const newState = { ...state, list: newList, current: resourceKey }
    return newState
  },
  [types.SET_CURRENT_RESOURCE](state, action) {
    const { resourceKey } = action
    const newState = { ...state, current: resourceKey }
    return newState
  },
})
